// extracted by mini-css-extract-plugin
export default {"contactUs":"contactUs_contactUs__kxj7+","contactUs_title":"contactUs_contactUs_title__pPUmF","Shimiring":"contactUs_Shimiring__wCkW3"};